import { isElementInViewport } from 'JBPlugin/in-viewport';
import { Loading } from 'JBSrc/constants';

const loadMorePagesButtonClass = '.ajax-infinity-page-link';

jQuery($ => {

	// AJAX INFINITE SCROLL PAGINATION
	$(document).on('click', loadMorePagesButtonClass, function(e) {
		e.preventDefault();
		ajaxLoadMore();
	});

	let ajaxLoadMore = function(){
		$(loadMorePagesButtonClass).attr('disabled', 'disabled');

		let path = document.createElement('a');
		let container = $(loadMorePagesButtonClass).data('container');
		path.href = $(loadMorePagesButtonClass).attr('href');
		let nextpage = path.pathname + path.search;
		if (nextpage.substr(0, 5) !== '/ajax') {
			nextpage = '/ajax' + path.pathname + path.search;
		}

		$(loadMorePagesButtonClass).html(Loading.icon + ' loading more');
		$.get(nextpage, function(html) {
			$(container).append(html);

			if ($('.ajax-load-more[data-container="' + container + '"]').length) {
				$('.ajax-load-more[data-container="' + container + '"]').html('');

				if ($(container).find('.ajax-pagination').length) {
					$('.ajax-load-more[data-container="' + container + '"]').html($(container).find('.ajax-pagination').html());
					$(container).find('.ajax-pagination').remove();
				}else{
					$('.ajax-load-more[data-container="' + container + '"]').remove();
				}
			}
			$(loadMorePagesButtonClass).removeAttr('disabled');

			//For when there is a masonry grid
			if(window.masonryCards !== undefined){
				window.masonryCards.appended(html);
				window.masonryCards.reloadItems();

				setTimeout(function () {
					window.masonryCards.layout();
				}, 350);
			}
		});
	};

	let ajaxInfinityPagination = function() {
		if (!$(loadMorePagesButtonClass).length) {
			return;
		}
		if (isElementInViewport($(loadMorePagesButtonClass))) {
			if (!$(loadMorePagesButtonClass).is('[disabled=disabled]')) {
				ajaxLoadMore();
			}
		}
	};
	window.addEventListener('resize', ajaxInfinityPagination);
	window.addEventListener('scroll', _.throttle(ajaxInfinityPagination, 500));
});
